import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import { v4 } from 'node-uuid';
import classnames from 'classnames';
import SaveProfileButton from 'profile/containers/save_profile_button';
import DropdownMenu from 'profile/components/header_menu';
import CreativeMenu from 'profile/containers/creative_menu';
import InviteModal from 'invite/containers/modal';
import Icon from 'common/components/svg_icon';

const HeaderButtons = ({
  user, profileUsername, isEditing, portfolio, togglePortfolioEdit, portfolioEditMode,
  yourEntries, toggleRightDrawer, isLoading
}) => {

  if (isLoading) {
    return null;
  }

  let isOwner = false;
  let isClient = false;
  let button = null;

  if (user.logged_in && user.profile_data) {
    isOwner = profileUsername === user.profile_data.username;
    isClient = user.profile_data.is_client;
  }

  /* viewing own entries */
  if (yourEntries) {
    button = (
      <div className="hide-for-large button-wrapper">
        <button
          type="button"
          onClick={toggleRightDrawer}
          className="btn btn-icon-only btn-filter header-btn-filter"
        >
          <Icon className={classnames('svg-icon', 'svg-icon-lg', 'filter')} icon="filter" />
        </button>
      </div>
    );

  /* editing own profile */
  } else if (isOwner && isEditing) {
    button = <SaveProfileButton />;

  /* viewing own profile */
  } else if (isOwner && !portfolio && !isEditing) {
    button = (
      <div className="header-controls profile-header button-wrapper">
        <Link to={`/users/${profileUsername}/edit/`} className="btn btn-primary">
          Edit
        </Link>
      </div>
    );

  /* viewing or editing own portfolio */
  } else if (isOwner && portfolio) {
    button = (
      <div className="header-controls profile-header button-wrapper">
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => togglePortfolioEdit(profileUsername)}
        >
          { portfolioEditMode ? 'Save' : 'Edit' }
        </button>
      </div>
    );
  }

  return (
    <div className="header-controls">
      <DropdownMenu profileUsername={profileUsername}/>

      <div className="hide-for-small-only">
        <CreativeMenu />
      </div>

      { button }

      { isClient && !isOwner && <InviteModal /> }
    </div>
  );
}

HeaderButtons.propTypes = {
  user: PropTypes.object,
  profileUsername: PropTypes.string,
  isEditing: PropTypes.bool,
  isLoading: PropTypes.bool,
  portfolio: PropTypes.bool,
  yourEntries: PropTypes.bool,
  portfolioEditMode: PropTypes.bool,
  togglePortfolioEdit: PropTypes.func,
  toggleRightDrawer: PropTypes.func,
};

export default HeaderButtons;



// WEBPACK FOOTER //
// ./profile/components/header_buttons.jsx